// Vue Packages
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import MuseUI from 'muse-ui';
import Toast from 'muse-ui-toast';
import Loading from 'muse-ui-loading';
import VuexI18n from 'vuex-i18n'
import Toasted from 'vue-toasted';
import VueProgress from 'vue-progress-path'
import ReadMore from 'vue-read-more';
import VueTouch  from 'vue-touch';
import { VTooltip } from 'v-tooltip'
import ResSplitPane from 'vue-resize-split-pane'

// Library
import axios from 'axios'
import echarts from 'echarts'

// Project Defined Files
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/translate'

// CSS Files
import '@/assets/css/transition.css'
import '@/assets/css/tooltip.css'
import '@/assets/css/emoji.css'
import '@/assets/css/videojs-thumbnails.css'
import 'muse-ui/dist/muse-ui.css';
import 'muse-ui-loading/dist/muse-ui-loading.css';
import 'video.js/dist/video-js.css'
import 'swiper/dist/css/swiper.css'
import 'vue-progress-path/dist/vue-progress-path.css'

// SCSS Files
import '@/assets/css/main.scss'
import '@/assets/css/editor.scss'
import '@/assets/css/menubar.scss'
import '@/assets/css/menububble.scss'

// Themes
import defaultLight from '@/themes/default-light.js';
import defaultDark from '@/themes/default-dark.js';
import red from '@/themes/red.js';
import blue from '@/themes/blue.js';
import green from '@/themes/green.js';
import carbon from '@/themes/carbon.js';

MuseUI.theme.add('default-light', defaultLight, 'light');
MuseUI.theme.add('default-dark', defaultDark, 'dark');
MuseUI.theme.add('red-light', red, 'light');
MuseUI.theme.add('red-dark', red, 'dark');
MuseUI.theme.add('blue-light', blue, 'light');
MuseUI.theme.add('blue-dark', blue, 'dark');
MuseUI.theme.add('green-light', green, 'light');
MuseUI.theme.add('green-dark', green, 'dark');
MuseUI.theme.add('carbon-light', carbon, 'light');
MuseUI.theme.add('carbon-dark', carbon, 'dark');

MuseUI.theme.addCreateTheme((theme) => {
  return `
  .vue-progress-path .progress {
  stroke: ${theme.primary} !important;
  }
  .mu-expansion-toggle-btn.mu-button {
  color: ${theme.text.primary} !important;
  }
  `;
});

// Assets
import hkuLogo from "@/assets/img/hku-logo.png";
import teliLogo from "@/assets/img/teli-logo.png";
import voxLogo from "@/assets/img/vox-logo.svg";
import voxLogoNoText from "@/assets/img/vox-logo-no-text.png";
import channelDefault from "@/assets/img/channel-default.png";
import videoDefaultPoster from "@/assets/img/introduction-Video-Front-Photo.jpg";


// Apply Library
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts

// Apply Vue Packages
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(MuseUI);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(VuexI18n.plugin, store);
Vue.use(Toasted, {
  theme: "outline",
  position: "bottom-right",
  duration: 0
});
Vue.use(VueProgress);

Vue.use(ReadMore);
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip)
Vue.component('rs-panes', ResSplitPane)
Vue.mixin({
  computed: {
    logo() {
      return voxLogo;
    },
    logoNoText() {
      return voxLogoNoText;
    },
    hkuLogo() {
      return hkuLogo;
    },
    teliLogo() {
      return teliLogo;
    },
    channelDefault() {
      return channelDefault;
    },
    videoDefaultPoster(){
      return videoDefaultPoster;
    },
  }
})

// Production Tip
Vue.config.productionTip = false

// router guard
router.beforeEach((to, from, next) => {
  if (store.getters.authorized) {
    store.commit("updateRoute", to);
  }
  next();
});

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  store.commit('fetching', true);
  return config;
  }, function (error) {
  // Do something with request error
  store.commit('fetching', false);
  return Promise.reject(error);
  });

axios.interceptors.response.use(function (response) {
  // Do something with response data
  store.commit('fetching', false);
  return response;
  }, function (error) {
  // Do something with response error
  store.commit('fetching', false);
  if(error.response.status === 401) {
    if(error.response.data.message === 'Token Expired') {
      Toast.error(Vue.i18n.translate('toast.logout'));
    }
    store.commit("logout");
  }
  return Promise.reject(error);
  });
  
export const bus = new Vue();

// New Vue instance
new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
